import { FormattedMessage, useIntl } from "react-intl";
import { CardMessageWrapper, CardMessage } from "components/Message";
import CustomIcon from "components/CustomIcon";
import icons from "enums/icons";
import useAppziWidget from "utils/hooks/useAppziWidget";

export const BBCompletePaceError = ({ callBack }: { callBack: () => void }) => {
    const intl = useIntl();

    return (
        <CardMessageWrapper sx={{ backdropFilter: "blur(4px)" }}>
            <CardMessage
                color="primary"
                sx={{ maxWidth: "420px !important" }}
                title={intl.formatMessage({
                    id: "pace.myDashboard.completePace.alert.title",
                })}
                content={<FormattedMessage id="pace.myDashboard.completePace.alert.message" />}
                actions={[
                    {
                        label: intl.formatMessage({
                            id: "pace.myDashboard.completePace.alert.button",
                        }),
                        onClickAction: callBack,
                    },
                ]}
            />
        </CardMessageWrapper>
    );
};

export const BBNoDataError = () => {
    const intl = useIntl();
    const { handleOpenWidget } = useAppziWidget();

    return (
        <CardMessageWrapper sx={{ backdropFilter: "blur(4px)" }}>
            <CardMessage
                sx={{ maxWidth: "550px !important" }}
                title={intl.formatMessage({
                    id: "charts.behaviouralBreakdown.popOver.title",
                })}
                content={<FormattedMessage id="charts.behaviouralBreakdown.popOver.description" />}
                actions={[
                    {
                        startIcon: (
                            <CustomIcon icon={icons.dialogBubble} sx={{ fontSize: 16, color: "common.white" }} />
                        ),
                        label: intl.formatMessage({
                            id: "charts.behaviouralBreakdown.popOver.action.label",
                        }),
                        onClickAction: handleOpenWidget,
                    },
                ]}
            />
        </CardMessageWrapper>
    );
};
